import type { Story, StoryCategory } from '@benzinga/advanced-news-manager';
import { News } from '@benzinga/basic-news-manager';

export const getPrimaryTickers = (tickers?: StoryCategory[]) => {
  if (!Array.isArray(tickers)) return [];
  return tickers
    .sort((a, b) => (a.primary === b.primary ? 0 : a.primary ? -1 : 1))
    .map(ticker => ticker?.name)
    .filter((name): name is string => typeof name === 'string' && name.length > 0);
};

export const getArticleTagsNames = (articleData: Story): string[] => {
  const tags = articleData?.getTags();
  if (Array.isArray(tags)) {
    return tags.map(item => item.name);
  } else {
    return [];
  }
};

export const getNodeTagsNames = (node: News): string[] => {
  if (Array.isArray(node?.tags)) {
    return node.tags.map(item => item.name);
  } else {
    return [];
  }
};

export const getArticleChannelsNames = (articleData: Story): string[] => {
  const channels = articleData.getChannels();
  if (Array.isArray(channels)) {
    return channels.map(item => item.name);
  } else {
    return [];
  }
};

export const getNodeChannelsNames = (node: News): string[] => {
  if (Array.isArray(node?.channels)) {
    return node.channels.map(item => item.name);
  } else {
    return [];
  }
};

export const getArticleTickers = (articleData: Story): string[] => {
  const tickers = articleData.getTickers();
  if (Array.isArray(tickers)) {
    return tickers.map(item => item.name);
  } else {
    return [];
  }
};

export const filterRelatedNodes = (story: Story, nodes: News[]): News[] => {
  const relatedArticles: News[] = [];
  const matchedArticles = {};

  const storyTags = getArticleTagsNames(story);
  let storyChannels = getArticleChannelsNames(story);
  storyChannels = storyChannels.filter(channelName => !['Cannabis', 'News', 'Markets'].includes(channelName));

  if (Array.isArray(nodes)) {
    nodes.forEach(node => {
      const nodeTags = getNodeTagsNames(node);
      let nodeChannels: string[] = [];
      let matchedChannels: string[] = [];

      if (storyChannels.length) {
        nodeChannels = getNodeChannelsNames(node);
        matchedChannels = nodeChannels.filter(value => storyChannels.includes(value));
      }

      const matchedTags = nodeTags.filter(value => storyTags.includes(value));

      if (
        node.id &&
        (matchedTags.length || matchedChannels.length) &&
        story.getNodeId() !== node.id &&
        !matchedArticles[node.id]
      ) {
        matchedArticles[node.id] = true;
        relatedArticles.push(node);
      }
    });
  }

  return relatedArticles;
};

export const isTaxonomyExists = (queryTaxonomiesNames: string[], taxonomies: StoryCategory[]): boolean => {
  if (Array.isArray(taxonomies) && Array.isArray(queryTaxonomiesNames)) {
    return taxonomies?.some(item => {
      return queryTaxonomiesNames.includes(item.name);
    });
  }

  return false;
};
